import React from 'react';
import {getDateStyle, isDatePassed, getDatePastDueTextShortMsg, pastDueStyle} from './CorrectedAgeManager/correctedAgeUtils';

interface AppointmentsProps {
    recommendedAbrStartDate: string;
    recommendedAbrEndDate: string;
    recommendedHearingTest1StartDate: string;
    recommendedHearingTest1EndDate: string;
    recommendedHearingTest2Date: string;
    recommendedHearingTest3Date: string;
}

const Monitoring: React.FC<AppointmentsProps> = ({
    recommendedAbrStartDate,
    recommendedAbrEndDate,
    recommendedHearingTest1StartDate,
    recommendedHearingTest1EndDate,
    recommendedHearingTest2Date,
    recommendedHearingTest3Date,
}) => {
    const containerStyle = {
        display: 'flex',
        flexDirection: 'column' as const,
        direction: 'rtl' as const,
        // border: '1px solid #ccc',
        // borderRadius: '5px',
        // padding: '15px',
        // boxShadow: '0 2px 4px #0000001a',
        position: 'relative' as const,
        overflow: 'hidden',
        gap: '20px'
      };

  const sectionStyle = {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '2px'
  };

  const appointmentItemStyle = {
    display: 'flex',
    flexWrap: 'wrap' as const,
    alignItems: 'baseline',
    gap: '8px',
    marginBottom: '10px',
    marginRight: '20px',
    direction: 'rtl' as const,
  };

  const dateContainerStyle = {
    display: 'flex',
    alignItems: 'baseline',
    gap: '4px',
    flexWrap: 'wrap' as const,
  };

  const descriptionStyle = {
    textAlign: 'right' as const,
  };

  return (
    <div style={containerStyle}>
      <div style={sectionStyle}>
        <div style={appointmentItemStyle}>
          <div style={descriptionStyle}>
            אבחון ABR
          </div>
          <span>:</span>
          <div style={dateContainerStyle}>
            <span style={getDateStyle(recommendedAbrEndDate)}>
              {recommendedAbrEndDate}
              {isDatePassed(recommendedAbrEndDate) &&
                <span style={pastDueStyle}>
                  {getDatePastDueTextShortMsg(recommendedAbrEndDate)}
                </span>
              }
            </span>
            {' '} - {' '}
            <span style={getDateStyle(recommendedAbrStartDate)}>
              {recommendedAbrStartDate}
              {isDatePassed(recommendedAbrStartDate) &&
                <span style={pastDueStyle}>
                  {getDatePastDueTextShortMsg(recommendedAbrStartDate)}
                </span>
              }
            </span>
          </div>
        </div>
      </div>

      <div style={sectionStyle}>
        <h4 style={{ marginRight: 20 }}>בדיקות התנהגותיות</h4>
        <div style={appointmentItemStyle}>
          <div style={descriptionStyle}>
            תור לגיל 7-8 חודשים
          </div>
          <span>:</span>
          <div style={dateContainerStyle}>
            <span style={getDateStyle(recommendedHearingTest1EndDate)}>
              {recommendedHearingTest1EndDate}
              {isDatePassed(recommendedHearingTest1EndDate) &&
                <span style={pastDueStyle}>
                  {getDatePastDueTextShortMsg(recommendedHearingTest1EndDate)}
                </span>
              }
            </span>
            {' '} - {' '}
            <span style={getDateStyle(recommendedHearingTest1StartDate)}>
              {recommendedHearingTest1StartDate}
              {isDatePassed(recommendedHearingTest1StartDate) &&
                <span style={pastDueStyle}>
                  {getDatePastDueTextShortMsg(recommendedHearingTest1StartDate)}
                </span>
              }
            </span>
          </div>
        </div>
        <div style={appointmentItemStyle}>
          <div style={descriptionStyle}>
            תור לגיל שנה וחצי
          </div>
          <span>:</span>
          <div style={dateContainerStyle}>
            החל מ - <span style={getDateStyle(recommendedHearingTest2Date)}>
              {recommendedHearingTest2Date}
              {isDatePassed(recommendedHearingTest2Date) &&
                <span style={pastDueStyle}>
                  {getDatePastDueTextShortMsg(recommendedHearingTest2Date)}
                </span>
              }
            </span>
          </div>
        </div>
        <div style={appointmentItemStyle}>
          <div style={descriptionStyle}>
            תור לגיל שנתיים וחצי
          </div>
          <span>:</span>
          <div style={dateContainerStyle}>
            החל מ - <span style={getDateStyle(recommendedHearingTest3Date)}>
              {recommendedHearingTest3Date}
              {isDatePassed(recommendedHearingTest3Date) &&
                <span style={pastDueStyle}>
                  {getDatePastDueTextShortMsg(recommendedHearingTest3Date)}
                </span>
              }
            </span>
          </div>
        </div>
      </div>
      <h4 style={{ marginRight: 20 }}>לאחר גיל 3 בהתאם להמלצות הצוות המטפל</h4>
    </div>
  );
};

export default Monitoring;